const getValueByPath = (obj: any, path: string) => {
    return path.split(".").reduce((acc, key) => {
        if (acc && acc[key] !== undefined) return acc[key]
        return undefined
    }, obj)
}

const isEmpty = (value: any) => {
    return value === undefined || value === null || value === ""
}

export const validateInputs = (inputs: any[], state: any, setErrors:any) => {
    const errors: { id: string; error: string, label: string }[] = []

    inputs.forEach((input) => {
        if (!input?.name || !input?.required) return

        const value = getValueByPath(state, input.name)
        if (isEmpty(value)) {
            errors.push({
                id: input.id,
                error: "Campo obrigatorio",
                label: input.label
            })
        }
    })
    setErrors(errors)
    return errors
}